import type { GatewayFlow } from "./types";

/**
 * Whether an answer of `GET /agent-gateways/{id}/flow` is the flow.
 *
 * The backend always answers the object (its totals default to zeros; a store it
 * cannot read is named in `unavailable`, never an error). What the console cannot
 * rule out is something else answering in its place with HTTP 200 — a proxy's
 * fallback, a stub, a backend half way through a deploy. The three readers of the
 * flow dereference `totals` and `nodes` while rendering, so a `[]` there took the
 * whole Overview down (found in a console smoke, 2026-10-13).
 */
export function isGatewayFlow(answer: unknown): answer is GatewayFlow {
  if (typeof answer !== "object" || answer === null || Array.isArray(answer)) return false;
  const flow = answer as Partial<GatewayFlow>;
  const totals = flow.totals as Partial<GatewayFlow["totals"]> | null | undefined;
  return (
    typeof totals === "object" &&
    totals !== null &&
    typeof totals.calls === "number" &&
    typeof totals.stopped === "number" &&
    Array.isArray(flow.nodes) &&
    Array.isArray(flow.links) &&
    Array.isArray(flow.unavailable)
  );
}

/** The flow, or an error the query reports like any failed read. */
export function asGatewayFlow(answer: unknown): GatewayFlow {
  if (!isGatewayFlow(answer)) throw new Error("The gateway's traffic could not be read");
  return answer;
}
